import React, { useEffect, useState } from "react"
import { Container, Card, CardBody, Row, Col } from "reactstrap"
import classNames from "classnames"
import moment from "moment"
import Swal from "sweetalert2"
import ReactSelect from "react-select"
import Calendar from "react-calendar"
import "../../assets/css/Calender/Devcalender.css"
import { colourStyles, workingtimeSlots } from "utils/common-options"
import { parseDateTimeSlot } from "utils/common-helpers"
import { fetchNodeData , FetchNodePostData , FetchNodePutData } from "utils/common-fetchData"
import Loader from "pages/Separate/Loader"
import configure from "configure"
import axios from "axios"
import { useParams } from "react-router-dom"
import zithasLogo from "../../assets/images/zithasLogo.png"
import { setContext } from "redux-saga/effects"
import { useLocation } from "react-router-dom";
import secureLocalStorage from "react-secure-storage"

const StepNavigationStep = ({ step, currentStep, onStepChange }) => {

  
  const classes = classNames({
    active: step.id === currentStep,
    complete: currentStep > step.id,
  })

  return (
    <li
      className={classes}
      onClick={() => {
        if (currentStep >= step.id) {
          onStepChange(step.id)
        }
      }}
    >
      <div className="step">
        <i className={step.icon_class}></i>
      </div>
      <div className="caption hidden-xs hidden-sm">
        <span className=" fontCaption">{step.title}</span>
      </div>
    </li>
  )
}

const StepNavigation = ({ steps, currentStep, onStepChange }) => {
  return (
    <ol className="step-indicator">
      {steps.map(step => (
        <StepNavigationStep
          key={step.id}
          step={step}
          currentStep={currentStep}
          onStepChange={onStepChange}
        />
      ))}
    </ol>
  )
}

const CalenderIndex3 = () => {
    const token = secureLocalStorage.getItem("auth_token")
  const { encodedUsers, id } = useParams();
  const [currentStep, setCurrentStep] = useState(1)
  const location = useLocation();
const [selectedUserIds, setSelectedUserIds] = useState([]);
  const [allBookingData, setAllBookingData] = useState([])
  const [selectedDate, setSelectedDate] = useState(new Date())

  const getMeetings = async (selectedStaff) => {
    const formEntries = {
      id: selectedStaff?.map(obj => obj?.value),
    }
    const res = await FetchNodePostData(
      toggleLoading,
      `calender/get`,
      token,
      formEntries
    )
    console.log("Meeting Data",res.data?.data);
    if (res?.status) {
      const meetData = res.data?.data?.map((teamItem, index) => {
        return {
          id: index + 1,
          title: teamItem.title,
          date: moment(teamItem.start),
          link: teamItem.onlineMeeting?.joinUrl,
          timeslot: teamItem?.timeslot,
          classNames: "bg-calender-content h-100",
          startDate: teamItem?.start,
          endDate: teamItem?.end,
          ...teamItem,
        }
      })
      setAllBookingData(meetData)
    }
  }

    useEffect(() => {
      fetch()
      getMeetings([{ value: localStorage.getItem("auth_id") }])
    }, [])

  //Seconddddddddddd
useEffect(() => {
  if (!selectedDate || !allBookingData?.length) return;

  const selectedDay = moment(selectedDate).format("YYYY-MM-DD");

  const takenSlots = workingtimeSlots.filter(slot => {

    // Extract START time from "02:00 PM - 02:30 PM"
    const slotStartTime = slot.value.split("-")[0].trim();

    const slotStart = moment(
      `${selectedDay} ${slotStartTime}`,
      "YYYY-MM-DD hh:mm A"
    );

    return allBookingData.some(meeting => {

      const meetingDate = moment(meeting.start).format("YYYY-MM-DD");
      if (meetingDate !== selectedDay) return false;

      const meetingStart = moment(meeting.start);
      const meetingEnd = moment(meeting.end);

      // Block
      return slotStart.isSameOrAfter(meetingStart) &&
             slotStart.isBefore(meetingEnd);
    });

  }).map(slot => slot.value);

  setBookedSlots(takenSlots);

}, [selectedDate, allBookingData]);




useEffect(() => {
  if (encodedUsers) {
    try {
      // Decode Base64 users
      const decoded = atob(decodeURIComponent(encodedUsers));
      const userIds = JSON.parse(decoded);
      const numericIds = userIds.map(id => Number(id));

      console.log("Decoded user IDs:", numericIds);
      setSelectedUserIds(numericIds);
    } catch (err) {
      console.error("Error decoding users from path:", err);
    }
  }
}, [encodedUsers]);


const extractedId = id?.match(/\d+/)?.[0] || null;
console.log("Extracted numeric ID:", extractedId);
const [userId, setUserId] = useState(extractedId);

  // Step 1

  const [selectedSlot, setSelectedSlot] = useState("")

  // Step 2
  const [meetingTitle, setMeetingTitle] = useState("")
  const [link, setLink] = useState("")
  const [name, setName] = useState("")
  const [email, setEmail] = useState("")
  const [contact, setContact] = useState("")
  const [description, setDescription] = useState("")
  const [loading, setLoading] = useState(false)
  const [bookedSlots, setBookedSlots] = useState([])

  //previous logic

  // useEffect(() => {
  //   if (!selectedDate) return

  //   fetchBookedSlots()
  // }, [selectedDate])

  // const fetchBookedSlots = async () => {
  //   try {
  //     toggleLoading(true)
  //     const dateStr = moment(selectedDate).format("YYYY-MM-DD")

  //     const body = {
  //       user_id: userId,
  //       date: dateStr,
  //     }

  //     const response = await axios.post(
  //       `${configure.nodeApi}/freeTimeSlots`,
  //       body
  //     )

  //     if (response.data.success) {
        
  //       const taken = response.data.data.map(item => item.timeslot)
  //       setBookedSlots(taken)
  //     }
  //   } catch (error) {
  //     console.error("Error fetching booked slots:", error)
  //   } finally {
  //     toggleLoading(false)
  //   }
  // }

  // Time Slots

  const steps = [
    { id: 1, title: "Select Date & Time", icon_class: "bi bi-1-circle-fill" },
    { id: 2, title: "Meeting Details", icon_class: "bi bi-2-circle-fill" },
  ]

  const stepChanged = step => setCurrentStep(step)

  // Save & Next logic
  const onSaveNext = () => {
    if (currentStep === 1) {
      if (!selectedDate || !selectedSlot) {
        Swal.fire({
          icon: "warning",
          text: "Please choose date & time slot",
        })
        return
      }
      setCurrentStep(2)
    } else if (currentStep === 2) {
      // handleAddMeeting()
      // handleSubmit() // ✔️ call final submit
    }
  }

  const toggleLoading = loading => {
    setLoading(loading)
  }
  const handleAddMeeting = async (e) => {
     e.preventDefault();
    const confirm = await Swal.fire({
      title: "Are you sure?",
      text: "Do you want to book this meeting?",
      icon: "question",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes, Book it!",
      cancelButtonText: "Cancel",
    })

    // If user cancels → stop here
    if (!confirm.isConfirmed) return
    console.log("clg: function called")

    try {
      toggleLoading(true)

      const dateStr = moment(selectedDate).format("YYYY-MM-DD")
      const dates = parseDateTimeSlot(dateStr, selectedSlot)

      const formEntries = {
        title: meetingTitle,
        location: 1,
        timezone: "Asia/Kolkata",
        imp: 0,
        user_id: 1,
        attendees: [userId,...selectedUserIds],
        otheratendees : selectedUserIds,
        aemail: [],
        date: dateStr,
        startDate: dates.start,
        endDate: dates.end,
        timeslot: selectedSlot,
        meeting_with: 5,
        description: description,
        meeting_link: link,
        recurring: 0,
        recurring_days: [],
        introducer_included: 0,
        name,
        email,
        contact,
      }

      console.log("BODY:", formEntries)

      const res = await axios.post(
        `${configure.nodeApi}/calender`,
        formEntries
      )

      if (res?.status) {
        Swal.fire({
          icon: "success",
          text: "Your meeting has been successfully booked.",
        }).then(() => {
          // RESET ALL FIELDS (like reload)
          setMeetingTitle("")
          setSelectedSlot("")
          setDescription("")
          setSelectedDate(new Date())

          // RESET WIZARD TO STEP 1
          setCurrentStep(1)
          window.location.reload()
        })
      }
    } catch (error) {
      console.error("Error creating meeting:", error)

      Swal.fire({
        icon: "error",
        title: "Error",
        text: "Something went wrong while booking the meeting!",
      })
    } finally {
      toggleLoading(false)
    }
  }

  const isPastTime = (slotValue, selectedDate) => {
    // Only check past time if selected date is today
    const today = moment().format("YYYY-MM-DD")
    const selected = moment(selectedDate).format("YYYY-MM-DD")

    if (today !== selected) return false

    // Extract START time from slot
    // "07:00 AM - 07:30 AM" → "07:00 AM"
    const startTime = slotValue.split(" - ")[0]

    const slotDateTime = moment(`${today} ${startTime}`, "YYYY-MM-DD hh:mm A")

    return slotDateTime.isBefore(moment())
  }

  return (
    <div className="">
      {loading && <Loader />}
      <Container fluid>
                <form
                    onSubmit={handleAddMeeting}
                    // style={{ paddingLeft: "180px", paddingRight: "180px" }}
                     className="responsive-form-wrapper"
                  >
        <Row>
          <Col lg={12} className="p-0">
            <Card>
              <CardBody className="pb-5">
                {/* Header + Save Button */}
                <div className="d-flex justify-content-between align-items-center wizard">
                  <img
                    src={zithasLogo}
                    alt="Logo"
                    style={{
                      width: "150px",
                    }}
                  />
                  <h4 className="mb-0 fw-bold text-purple">Schedule a Meeting</h4>

                  <div>
              <button
  type={currentStep === 1 ? "button" : "submit"}
  className="btn text-white btn-save btn-label border-radius"
  onClick={currentStep === 1 ? onSaveNext : undefined}
>
  <i className="fas fa-save label-icon"></i>
  {currentStep === 1 ? "Save & Next" : "Submit"}
</button>

                  </div>
                </div>

                {/* Steps */}
                <div className="container-fluid mt-3">
                  <StepNavigation
                    steps={steps}
                    currentStep={currentStep}
                    onStepChange={stepChanged}
                  />
                </div>
              </CardBody>
            </Card>

            {/* Step 1 */}
            {currentStep === 1 && (
              <Card className="mt-6">
                <CardBody>
                  <Row>
                    {/* LEFT COLUMN — CALENDAR */}
                    <Col md={6}>
                      <div className="text-center">
                        <h5 className="mb-2 fw-bold text-uppercase">
                          Select Date
                        </h5>

                        <h2 className="selected-date-text text-purple">
                          {moment(selectedDate).format("ddd, MMM DD")}
                        </h2>

                        {/* Center calendar */}
                        <div className="d-flex justify-content-center mt-3">
                          <div className="col-md-8">
                            <Calendar
                              onChange={date => setSelectedDate(date)}
                              value={selectedDate}
                              minDate={new Date()}
                              className="react-calendar d-block mx-auto"
                            />
                          </div>
                        </div>
                      </div>
                    </Col>

                    {/* RIGHT COLUMN — TIME SLOTS */}
                    <Col md={6}>
                      <h4 className="fw-bold mt-md-2 mt-5 timeSlotClass" style={{ marginBottom: "30px" }}>
                        Select a Time Slot
                      </h4>

                      <div className="row g-3 responsiveSlots">
                        {workingtimeSlots.map(slot => {
                          const isBooked = bookedSlots.includes(slot.value)
                          const isPast = isPastTime(slot.value, selectedDate)

                          return (
                            <div className="col-6 col-md-4" key={slot.id}>
                              <button
                              type="button"
                                className={`
                                btn time-slot-btn w-100
                               ${selectedSlot === slot.value ? "selected-slot" : "unselected-slot"}
                               ${isBooked || isPast ? "time-slot-booked" : ""}
                               `}
                                disabled={isBooked || isPast}
                                onClick={() => {
                                  if (!isBooked && !isPast)
                                    setSelectedSlot(slot.value)
                                }}
                              >
                                {slot.label}
                              </button>
                            </div>
                          )
                        })}
                      </div>
                    </Col>
                  </Row>
                </CardBody>
              </Card>
            )}

            {/* Step 2 */}
            {currentStep === 2 && (
              <Card className="mt-3">
                <CardBody>
          
                    {/* FORM HEADER */}
                    {/* <div className="d-flex justify-content-center align-items-center mb-4 flex-wrap gap-3">

                      <div className="d-flex align-items-center col-12">
                        <div className="btn-meeting p-2 px-3 border-radius">
                          <div><i className="bi bi-calendar2 fs-5"></i></div>
                        </div>
                 
                        <div className="d-flex gap-1  align-items-center col-md-10 mb-10 mt-2">
                          <h4 className="mb-0 ps-2 col-md-4">Fill Your Details</h4>
                          <div className="d-flex gap-3 align-items-center flex-wrap">
                            <div className="px-3 py-2 rounded bg-light border d-flex align-items-center gap-2 shadow-sm">
                              <i className="bi bi-calendar-event text-primary"></i>
                              

                              <small className="text-muted fw-semibold fs-6">
                                Date :
                              </small>
                              <span className="fw-bold text-dark">
                                {moment(selectedDate).format("DD MMM YYYY")}
                              </span>
                            </div>

                            <div className="px-3 py-2 rounded bg-light border d-flex align-items-center gap-2 shadow-sm">
                              <i className="bi bi-clock text-success"></i>
                              <small className="text-muted fw-semibold fs-6">
                                Time :
                              </small>
                              <span className="fw-bold text-dark">
                                {selectedSlot || "Not Selected"}
                              </span>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div> */}

<div className="d-flex justify-content-start align-items-center mb-4 flex-wrap flex-md-nowrap gap-2">

  {/* Calendar Icon */}
  <div className="btn-meeting p-2 px-3 border-radius d-flex align-items-center">
    <i className="bi bi-calendar2 fs-5"></i>
  </div>

  {/* Heading */}
  <h4 className="mb-0 flex-shrink-0">Fill Your Details</h4>

  {/* Date & Time Blocks */}
  <div className="d-flex align-items-center gap-2 flex-wrap flex-md-nowrap ps-md-4">
    {/* Date Block */}
    <div className="px-2 py-1 rounded bg-light border d-flex align-items-center gap-1 shadow-sm">
      <i className="bi bi-calendar-event text-primary"></i>
      <small className="text-muted fw-semibold fs-6">Date :</small>
      <span className="fw-bold text-dark">
        {moment(selectedDate).format("DD MMM YYYY")}
      </span>
    </div>

    {/* Time Block */}
    <div className="px-2 py-1 rounded bg-light border d-flex align-items-center gap-1 shadow-sm">
      <i className="bi bi-clock text-success"></i>
      <small className="text-muted fw-semibold fs-6">Time :</small>
      <span className="fw-bold text-dark">
        {selectedSlot || "Not Selected"}
      </span>
    </div>
  </div>
</div>




                    

                    {/* TITLE */}
                    <div className="row">
                      <div className="col-md-6">
                        <label>Title</label>
                        <div className="d-flex align-items-center mb-3">
                          <i className="bi bi-pencil-square position-absolute ps-3 fs-5 text-link"></i>
                          <input
                            type="text"
                            placeholder="Add Title"
                            className="form-control ps-5"
                            value={meetingTitle}
                            onChange={e => setMeetingTitle(e.target.value)}
                          />
                        </div>
                      </div>
                      <div className="col-md-6">
                        <label>Link</label>
                        <div className="d-flex align-items-center mb-3">
                          <i className="bi bi-link position-absolute ps-3 fs-5 text-link"></i>
                          <input
                            type="text"
                            placeholder="Add Link"
                            className="form-control ps-5"
                            value={link}
                            onChange={e => setLink(e.target.value)}
                          />
                        </div>
                      </div>
                    </div>

                    {/* DATE + TIMESLOT */}
                    <div className="row ">
                      <div className="col-lg-12">
                        <div className="row mb-4 ">
                          {/* DATE */}
                          <div className="col-12 col-md-4  mb-3">
                            <label>
                              Name <span className="text-danger">*</span>
                            </label>
                             <div className="d-flex align-items-center mb-3">
                              <i className="bi bi-person position-absolute ps-3 fs-5 text-link"></i>

                            <input
                            
                              type="text"
                              placeholder="Add Name"
                              required
                              className="form-control ps-5"
                              value={name}
                              onChange={e => setName(e.target.value)}
                            />
                            </div>
                          </div>

                          {/* TIME SLOT */}
                          <div className="col-12 col-md-4  pb-3">
                            <label>
                              Email <span className="text-danger">*</span>
                            </label>
                             <div className="d-flex align-items-center mb-3">
                              <i className="bi bi-envelope position-absolute ps-3 fs-5 text-link"></i>

                            <input
                              type="text"
                              required
                              placeholder="Add Email"
                              className="form-control ps-5"
                              value={email}
                              onChange={e => setEmail(e.target.value)}
                            />
                            </div>
                          </div>
                          <div className="col-12 col-md-4  mb-md-3">
                            <label>
                              Contact <span className="text-danger">*</span>
                            </label>
                            <div className="d-flex align-items-center mb-3">
                              <i className="bi bi-phone position-absolute ps-3 fs-5 text-link"></i>

                            <input
                              type="text"
                              required
                              placeholder="Add Contact"
                              className="form-control ps-5"
                              value={contact}
                              onChange={e => setContact(e.target.value)}
                            />
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>

                    {/* DESCRIPTION */}
                    <div className="mb-3">
                      <label>Description</label>
                      <textarea
                        className="w-100 form-control"
                        placeholder="Add Description"
                        rows={5}
                        value={description}
                        onChange={e => setDescription(e.target.value)}
                      ></textarea>
                    </div>

                    {/* SUBMIT BUTTON */}
                    {/* <div className="me-2 d-flex justify-content-end">
                      <button
                        className="btn-meeting btn px-4 py-2"
                        onClick={handleSubmit}
                      >
                        Create
                      </button>
                    </div> */}
                
                </CardBody>
              </Card>
            )}
          </Col>
        </Row>
        </form>
      </Container>
    </div>
  )
}

export default CalenderIndex3
